export const PaySlipAnnex = {
    path: '/pay_slip_annexes',
    name: 'pay_slip_annexes',
    component: () => import('../views/PaySlipSynthesis/PaySlipAnnexPage.vue'),
    children: [
        {
            path: '/pay_slip_annexes/view/:id',
            name: 'pay_slip_annexes.view',
            component: () => import('@/views/PaySlipSynthesis/EtatRecapitulatif.vue'),
        },
        {
            path: '/pay_slip_annexes/set_decision/:id/:module',
            name: 'pay_slip_annexes.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/pay_slip_annexes/take_in_charge/:id/:module',
            name: 'pay_slip_annexes.take_in_charge',
            component: () => import('@/views/Request/Components/TakeInCharge.vue'),
        },
        {
            path: '/pay_slip_annexes/timelines/:id/:module',
            name: 'pay_slip_annexes.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/pay_slip_annexes/close/:id',
            name: 'pay_slip_annexes.close',
            component: () => import('@/views/PaySlipSynthesis/Form/CloseForm.vue'),
        },
        {
            path: '/pay_slip_annexes/delete/:id',
            name: 'pay_slip_annexes.delete',
            component: () => import('@/views/PaySlipSynthesis/Form/DeleteMonth.vue'),
        },
        {
            path: '/pay_slip_annexes/documents/:id',
            name: 'pay_slip_annexes.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "PAY_SLIP_ANNEX"}
        },
    ],
}